
/* injects from baggage-loader */

'use strict';

import ServiceUpdatesModalController from './serviceupdatesmodal.controller';
import ServiceUpdatesModalTemplate from './serviceupdatesmodal.html';

export default class ServiceUpdatesModalComponent {
		constructor() {
				this.templateUrl = ServiceUpdatesModalTemplate;
				this.controller = ServiceUpdatesModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
